module.exports = __webpack_public_path__ + "static/media/Elitebadge.3c877632.svg";